
import { Component, Vue, Prop} from 'vue-property-decorator';

import * as SurveyVue from "survey-vue";
import * as surveyEnv from "@/components/survey/survey-glossary";
import surveyJson from "./forms/enforce-agreement-order.json";


import PageBase from "../PageBase.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
        PageBase
    }
})

export default class EnforceAgreementOrder extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public steps!: stepInfoType[];    

    
    @applicationState.State
    public rejectedPathway!: boolean;
    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    survey = new SurveyVue.Model(surveyJson);   
    currentStep =0;
    currentPage =0; 
    confirmedError = false

    popInfo = false;
    popInfoUnderstand = ''

    beforeCreate() {
        const Survey = SurveyVue;
        surveyEnv.setCss(Survey);
    }

    mounted(){
        this.confirmedError = false
        this.initializeSurvey();
        this.addSurveyListener();
        this.reloadPageInformation();
    }

    public initializeSurvey(){       
        this.survey = new SurveyVue.Model(surveyJson);
        this.survey.commentPrefix = "Comment";
        this.survey.showQuestionNumbers = "off";
        this.survey.showNavigationButtons = false;
        surveyEnv.setGlossaryMarkdown(this.survey);
    }    
    
    public addSurveyListener(){
        this.survey.onValueChanged.add((sender, options) => {
            Vue.filter('surveyChanged')('agreementEnfrc')
            //console.log(options)  
            this.confirmedError = false          
        })
    }
    
    public reloadPageInformation() { 
        
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;

        if (this.step.result?.enforceAgreementOrOrderSurvey) {
            this.survey.data = this.step.result.enforceAgreementOrOrderSurvey.data; 
            Vue.filter('scrollToLocation')(this.$store.state.Application.scrollToLocationName);            
        }
        
        this.survey.setVariable("enableSurvey", !this.rejectedPathway)

        this.setProgress();
    }  

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public closePopup(){
        this.popInfo=false;
        Vue.prototype.$UpdateGotoNextStepPage()
    }

    public onNext() {
        if(!this.survey.isCurrentPageHasErrors) {
            //console.log(this.survey.data)
            if(this.survey?.data?.enforceOrder=="n" && this.survey?.data?.filedOrder=="n" &&this.survey?.data?.existingType=="courtOrder" )
                this.popInfo = true;            
            else
               Vue.prototype.$UpdateGotoNextStepPage()
        }
    }
    
    public setProgress(){        

        if(this.survey?.data?.enforceOrder=="n" && this.survey?.data?.filedOrder=="n" && this.survey?.data?.existingType=="courtOrder" && this.popInfoUnderstand != 'understand'){
            Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 50, false);
            this.confirmedError = true
            Vue.filter('scrollToLocation')('next-error')
            Vue.filter('surveyChanged')('agreementEnfrc')
        }
        else{
            Vue.filter('setSurveyProgress')(this.survey, this.currentStep, this.currentPage, 50, false);
            this.confirmedError = false
        }
    }
    
    beforeDestroy() {
        this.setProgress();
        this.UpdateStepResultData({step:this.step, data: {enforceAgreementOrOrderSurvey: Vue.filter('getSurveyResults')(this.survey, this.currentStep, this.currentPage)}})
    }
}
